export const getFirstEmailPart = (email: string): string => {
  if (!email || typeof email !== "string") return "";
  return email.split("@")[0];
};
